
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Image } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h4>Ein Kinderspielplatz, ein leeres Lokal und eine Verhaftung</h4>
    <p>
  Der Therapeut ist zu Besuch im «Palacio de la Paz». «Man sehe sofort, wie viel ihm dieses Projekt bedeute», hält er
  laut Untersuchungsbericht fest. William W. könne «seine kommunikativen Fähigkeiten voll ausleben». Am gleichen Tag
  meldet sich auch der Bewährungshelfer beim Amt für Justizvollzug: Ihm sei aufgefallen, dass unmittelbar neben dem
  Lokal ein Spielplatz liege. Wegen einer Baustelle habe er das erst jetzt bemerkt.
  <Image file={require('images/wBeiEroeffnung.jpg')} source='W. bei der Eröffnung seines Restaurants, das auch Tatort sein soll.' mdxType="Image" />
    </p>
    <p>
  Elf Tage später kommt es zum letzten Vorfall, der in der Anklageschrift beschrieben wird. Laut dieser soll W. einen
  Achtjährigen angesprochen haben, der auf dem Heimweg von der Schule war. Er habe dem Knaben angeboten, eine
  Gratis-Cola in seiner Beiz zu trinken. Dort habe er sich am Unterstufenschüler vergangen, so die Staatsanwaltschaft.
  Sexuelle Handlungen mit einem Kind und Schändung lauten die Vorwürfe. Bevor der Beschuldigte den Buben habe gehen
  lassen, wies er ihn laut Anklage darauf hin, «dass er niemandem etwas vom Vorgefallenen erzählen solle». Diese
  Einschüchterung funktioniert offenbar nicht, einen Tag später nimmt die Polizei William W. fest. Seine 24 Monate in
  Freiheit sind vorbei.
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;